<template>
  <div>
    <router-link v-if="!isMobile && !isSmallScreen" :to="{name: 'mesAccueils'}" class="back-link" title="Retour à mes accueils"><font-awesome-icon :icon="['fas', 'arrow-left']" size="2x" /><span class="sr-only">Retour à mes accueils</span></router-link>
    <EbHeading v-if="!isMobile && !isSmallScreen" level="h1" class="eb-page-heading">Déclarer la fin de l’accueil</EbHeading>
    
    <div class="eb-content-default w75">
      <EbEtiquette type="theme">Accueil en cours</EbEtiquette>
      <form v-if="enfant" action="#" @submit.prevent="setDeclarationDepart()">
        <div class="text-center">
          <font-awesome-icon :icon="['fas', 'baby']" size="2x" class="site-color" />
          <EbHeading level="h2" class="eb-box-heading-large">
            <span class="text-uppercase">{{ enfant.nom }}</span> {{ enfant.prenom }}
          </EbHeading>
          <ul>
            <li>Né(e) le : <time :datetime="enfant.dateNaissance">{{ getLongDate(enfant.dateNaissance) }}</time></li>
            <li>Date d’arrivée de l’enfant : <time :datetime="enfant.dateArrivee">{{ getLongDate(enfant.dateArrivee) }}</time></li>
          </ul>
        </div>
        
        <hr />
        
        <EbBanner :isActive="error" type="error" :timestamp="bannerTimestamp">Une erreur est survenue. Veuillez vérifier votre saisie.</EbBanner>
        
        <EbInput type="date" v-model="dateDepart" required label="Date de départ de l’enfant"></EbInput>
        
        <EbDisclosure v-model="addDispoFuture" label="Déclarer une disponibilité future" legend="Les informations de ma disponibilité future :" isSwitch groupTag="fieldset">
          <EbInput type="date" v-model="dateDispo" label="Place disponible à compter du" :min="minDate" :required="addDispoFuture?true:null"></EbInput>
          
          <fieldset v-if="agrement">
            <legend class="eb-legend-label">Tranches d’âge</legend>
            
            <EbRadio v-for="(a, index) in agrement.types" :label="a.trancheAge" v-model.number="a.idTrancheAge" :key="index" @input="changeTrancheAge" :checked="idTrancheAge == a.idTrancheAge ? true:false" name="tranchesages"></EbRadio>
          </fieldset>
          
          <EbBanner isActive type="info">Votre disponibilité future est transmise à votre service PMI et devient visible par les parents sur votre profil public.</EbBanner>
        </EbDisclosure>
        
        <div class="eb-button-group">
          <EbButton type="submit">Envoyer la déclaration</EbButton>
          <EbLinkButton :to="{name: 'mesAccueils'}" class="medium text">Annuler la saisie</EbLinkButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'clotureAccueilEnfant',
  props: {
    idEnfant: null,
  },
  data() {
    return {
      enfant: null,
      dateDepart: null,
      dateDispo: null,
      agrement: null,
      idTrancheAge: null,
      error: false,
      addDispoFuture: false,
      bannerTimestamp: null
    }
  },
  mounted() {
    this.getEnfant()
    this.getAgrement()
  },
  computed: {
    minDate: function() {
      const today = new Date()
      return today.toISOString().slice(0, 10)
    },
  },
  watch: {
    addDispoFuture: function() {
      if(this.idTrancheAge == null) {
        this.idTrancheAge = this.agrement.types[0].idTrancheAge
      }
      else {
        this.idTrancheAge = null
        this.dateDispo = null
      }
    }
  },
  methods: {
    getEnfant: async function() {
      await this.$http.get('assmat/enfants/' + this.idEnfant)
      .then(resp => {
        this.enfant = resp.data
      })
    },
    getAgrement: async function() {
      await this.$http.get('assmat/agrement')
      .then(resp => {
        this.agrement = resp.data
      })
    },
    setDeclarationDepart: async function() {
      await this.$http
      .put(`assmat/enfants/${this.idEnfant}/finAccueil`, {
        dateDepart: this.dateDepart,
        dateDispo: this.dateDispo,
        idTrancheAge: this.idTrancheAge,
      })
      .then(resp => {
        this.$router.push({name: 'mesAccueils', params: {status: 'delete'}})
      })
      .catch(error => {
        this.error = true
        this.bannerTimestamp = this.getTime()
      })
    },
    changeTrancheAge: function(value) {
      this.idTrancheAge = Number(value)
    }
  },
}
</script>